import { Stack, Typography, Grid } from '@mui/material';

import { toSentenceCase } from 'common/utils/utilFunctions';

import FileDropArea from '../FileDropArea/FileDropArea';

import styles from './FileUploadWithLargeDropArea.module.scss';

interface IFileUploadWithLargeDropAreaProps {
	title: string;
	subTitle: string;
	dragAreaTitle: string;
	maxfileSize?: number; // in MB
	maxFilesLimit?: number;
	uploadedFiles: File[];
	accept?: { [key: string]: string[] };
	setUploadedFiles: React.Dispatch<React.SetStateAction<File[]>>;
}
const FileUploadWithLargeDropArea = (
	props: IFileUploadWithLargeDropAreaProps,
) => {
	const {
		title,
		subTitle,
		dragAreaTitle,
		accept,
		uploadedFiles,
		setUploadedFiles,
		maxfileSize,
		maxFilesLimit,
	} = props;
	const dropAreaContainer = {
		display: 'flex',
		justifyContent: 'space-between',
	};
	return (
		<Stack gap={2} className={styles['section-container']}>
			<Grid container style={dropAreaContainer}>
				<Grid item data-testid="large-drop-area">
					<Typography className={styles.title}>
						{toSentenceCase(title)}
					</Typography>
					<Typography className={styles['sub-title']}>
						{toSentenceCase(subTitle)}
					</Typography>
				</Grid>
			</Grid>
			<Grid>
				<Grid item>
					<FileDropArea
						dragAreaTitle={dragAreaTitle}
						accept={accept}
						handleFileData={setUploadedFiles}
						fileData={uploadedFiles}
						maxfileSize={maxfileSize}
						maxFilesLimit={maxFilesLimit}
					/>
				</Grid>
			</Grid>
		</Stack>
	);
};

export default FileUploadWithLargeDropArea;
